import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShipmentsService } from 'src/app/core/services/basicServices/shipments.service';
import { Messages, Patterns } from 'src/app/helpers';

@Component({
  selector: 'app-add-edit-product',
  templateUrl: './add-edit-product.component.html',
  styleUrls: ['./add-edit-product.component.scss']
})
export class AddEditProductComponent implements OnInit {

  form: FormGroup;
  validationMessages = Messages.validation_messages;
  permissions: any;
  constructor(
    public dialogRef: MatDialogRef<AddEditProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
    public formBuilder: FormBuilder,
    private shipmentService: ShipmentsService,
  ) {
    if (data.id != null) {
      this.shipmentService.getSingleProductDimensions(data.id).subscribe(res => {
        if (res) {
          console.log(res)
          this.form.patchValue(res);
          console.log(this.form.value)
        }
      })
    }
  }
  ngOnInit(): void {
    this.validateForm();
  }
  
  validateForm() {
    this.form = this.formBuilder.group({
      id : new FormControl(null),
      productNo: new FormControl(null,Validators.required),
      name: new FormControl(null,Validators.required),
      dimUnit: new FormControl(null,Validators.required),
      length: new FormControl(0,Validators.compose([Validators.required, Validators.pattern(Patterns.decimalNum)])),
      width: new FormControl(0,Validators.compose([Validators.required, Validators.pattern(Patterns.decimalNum)])),
      height: new FormControl(0,Validators.compose([Validators.required, Validators.pattern(Patterns.decimalNum)])),
      weightUnit: new FormControl(null,Validators.required),
      weight: new FormControl(0,Validators.compose([Validators.required, Validators.pattern(Patterns.decimalNum)])),
    });
  }

  rateChange(value){
    if(value){
      if(value.value==0){
        this.form.get('rateValue').setValue(0)
      }
      else{
        this.form.get('ratePercentage').setValue(0)
      }
    }
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    this.shipmentService.createProductDimensions(this.form.value).subscribe(res=>{
      if(res){
        this.dialogRef.close("Success");
      }
      else{
        this.onNoClick();
      }
    })
  }

}
